import React from 'react';
import { Spinner, VStack } from 'native-base';
import { Text } from '../Text';
import type { ISpinnerProps } from './LoadingSpinner.types';

export const LoadingSpinner = ({ label, ...props }: ISpinnerProps) => (
  <VStack>
    <Spinner {...props} />
    {label && <Text fontSize={'sm'}>{label}</Text>}
  </VStack>
);
